import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const yoniTrades: SeasonTrades[] = [
    {
        season: "2022/23",
        allTrades: []
      },
      {
        season: "2023/24",
        allTrades: [
          {
            otherTeam: manager.mati,
            sentAway: "Mikal Bridges",
            gotInReturn: "Franz Wagner",
            amongBestTrades: true
          },
          {
            otherTeam: manager.yevgeny,
            sentAway: "De'Aaron Fox",
            gotInReturn: "CJ McCollum and Brandon Ingram"
          },
          {
            otherTeam: manager.idan,
            sentAway: "Tyrese Maxey and Keldon Johnson",
            gotInReturn: "Domantas Sabonis and Anfernee Simons",
            amongBestTrades: true
          },
          {
            otherTeam: manager.mati,
            sentAway: "Fred VanVleet",
            gotInReturn: "Jamal Murray"
          }
        ]
      }
]